import React from "react";
import { AccordionIcon, useAccordionItemState } from "@chakra-ui/react";
import { colours } from "@/theme/colours";

/** Points right while the accordion item is collapsed and down while it is expanded. */
export function AccordionChevron(): JSX.Element {
	const { isOpen } = useAccordionItemState();
	return (
		<AccordionIcon
			color={colours.text.regular}
			__css={{
				boxSize: "unset",
				width: "16px",
				height: "24px",
				transform: isOpen ? undefined : "rotate(-90deg)",
				transition: "transform 0.2s",
			}}
		/>
	);
}
